import { gql } from '@apollo/client';

export default class ServiceSettingsMutation {
static SAVE_DEFAULT_SERVICE_SETTINGS = gql`
  mutation saveDefaultServiceSettings($input: ServiceDefaultSettingsInput!, $lotName: String!) {
    saveDefaultServiceSettings(input: $input, lotName: $lotName)
  }
`;

static SAVE_SERVICE_METADATA = gql`
  mutation saveServiceMetadata($input: [EntityMetadataInput]!) {
    saveServiceMetadata(input: $input)
  }
`;
}
